import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FFE500",
      contrastText: "#000",
    },
    secondary: {
      main: "#45474B",
    },
  },
  typography: {
    fontFamily: "Roboto",
    fontWeightMedium: 600,
    allVariants: {
      "@media (max-width:1200px)": {
        fontSize: "0.9em",
      },
      "@media (max-width:800px)": {
        fontSize: "0.8em",
      },
    },
  },
  overrides: {
    // Menu background color
    MuiPaper: {
      root: {
        backgroundColor: "#F9F5D4",
      },
    },
    MuiButton: {
      label: {
        fontWeight: 600,
      },
    },
  },
});

export default theme;
